import React from "react";
import { Device } from "../../../types/Device";
import { DirectionalCount } from "../../../types/Count";
import { BaseDeviceCard } from "./base-device-card";
import { CardContent, Typography } from "@mui/material";

interface ViewOnlyDeviceCardProps {
    device: Device;
    count: DirectionalCount;
    videoId?: string;
}

export const ViewOnlyDeviceCard: React.FC<ViewOnlyDeviceCardProps> = ({
    device,
    count,
    videoId,
}) => {
    const renderContent = () => {
        return (
            <CardContent
                sx={{
                    minHeight: 150,
                    p: 0,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Typography variant="h4" component="p" align="center">
                    Counting Disabled
                </Typography>
            </CardContent>
        );
    };
    return (
        <BaseDeviceCard
            device={device}
            count={count}
            videoId={videoId}
            renderContent={renderContent}
            getDeviceType={() => "viewOnly"}
        />
    );
};
